import { httpHandler } from '@http/httpHelpers';
import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { IOrganizeState } from '../models/organize-state.model';
import { LayoutActionTypes } from './layout.action.types';

export const contactForm = createAsyncThunk(LayoutActionTypes.SENDMAIL, (emailBody: IOrganizeState) => {
	return httpHandler<IOrganizeState>(axios.post('/notifications/contact-form', emailBody));
});
